import { useContext, useEffect, useState } from "react";
import DocumentTitleContext from "contexts/DocumentTitleContext";
const useDocumentTitle = (title) => {
  const registry = useContext(DocumentTitleContext);
  if (!registry) {
    throw new Error("useDocumentTitle needs to be used inside DocumentTitleContextProvider.");
  }
  const [position] = useState(registry.reservePosition);
  useEffect(() => registry.register(title, position), [registry, title, position]);
};
export default useDocumentTitle;
